module.exports = __webpack_public_path__ + "img/helpIcon.2983d294.svg";